import { validAFM , validSumPercentage } from 'utils';
import { countriesList } from '../countriesList';
import { validateAFM } from 'utils/utilsLoans';

export const carrierUsersFields = (withBin = false, carrierUsers, index) => [
  {
    label: 'Ονοματεπώνυμο Εταίρου/Μετόχου',
    type: 'text',
    name: 'shareholderName',
    id: 'shareholderName',
    size: 'large',
    placeholder: 'Εισάγετε Ονοματεπώνυμο Εταίρου/Μετόχου',
    asterisk: true,
    span: withBin ? 8 : 9,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {validator(_, value) {
        const duplicateCount = carrierUsers.filter(u => u.shareholderName === value).length;

        if (duplicateCount > 1) {
          return Promise.reject('Το Ονοματεπώνυμο πρέπει να είναι μοναδικό ανά Εταίρο/Μέτοχο Φορέα');
        }
      },
    }

    ],
  },
  {
    label: 'Α.Φ.Μ.',
    type: 'text',
    name: 'shareholderVat',
    id: 'shareholderVat',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    maxLength: 15,
    asterisk: true,
    span: 4,
    // containerClassName: "name-width",
    rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
          () => ({
            validator(_, value) {
              const duplicateCount = carrierUsers.filter(u => u.shareholderVat === value).length;

              if (duplicateCount > 1) {
                return Promise.reject('Το Α.Φ.Μ. πρέπει να είναι μοναδικό ανά Εταίρο/Μέτοχο Φορέα');
              }
              return validateAFM(value);
            },
          }),
        ],
  },
  {
    label: 'Χώρα Εγκατάστασης',
    type: 'select',
    name: 'shareholderCountry',
    className: 'multiple-lines-field-select',
    id: 'shareholderCountry',
    size: 'medium',
    placeholder: 'Επιλέξτε Χώρα Εγκατάστασης',
    showSearch: true,
    options:countriesList,
    span: 6,
    asterisk: true,
    filterOption : (input, option) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
  },
  {
    label: 'Ποσοστό Συμμετοχής',
    type: 'numberWithDecimals',
    name: 'shareholderPercentage',
    id: 'shareholderPercentage',
    suffix: '%',
    size: 'large',
    placeholder: 'Εισάγετε % Συμμετοχής',
    maxLength: 12,
    decimalsLimit: 15,
    span: 5,
    className: 'shareHolderPercentage',
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {
        validator: (_, value) => {
          const currentValue = parseFloat(value.replaceAll(',','.')) || 0;
    
          const total = carrierUsers.reduce((sum, item, i) => {
            if (i === index) return sum + currentValue;
            const perc = parseFloat(item.shareholderPercentage) || 0;
            return sum + perc;
          }, 0);
    
          if (total > 100) {
            return Promise.reject('Το Ποσοστό Συμμετοχής δεν μπορεί να ξεπερνάει το 100%');
          }
    
          return validSumPercentage(currentValue);
        }
      }
    ]
  },
];
